import React, { Fragment } from 'react';

export const Shift = () => <Fragment>⇧</Fragment>;
